module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hot-acc"
  }, [_c('latestnews'), _vm._v(" "), _c('pricelist', {
    attrs: {
      "title": '热卖账号',
      "data": _vm.goodList,
      "page": _vm.goodsPage
    },
    on: {
      "showlogin": _vm.showLogin,
      "changepage": _vm.changeGoodsPage,
      "changepagesize": _vm.changeGoodsPageSize
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aeb394f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hotAcc/hotAcc.vue
// module id = 634
// module chunks = 27